const usageFeesColHeads = [
  {"key": "product", "title": "Products"},
  {"key": "usageFeeForAccount", "title": "Account Custom Usage Fees"},
  {"key": "usageFee", "title": "Global Usage Fees"}
]

const usageFeesProductInfo = [
  { id: "ANCHOR", name: "Anchor Ad Unit", section: "Full Ad Management"},
  { id: "APP", name: "Mobile App", section: "Mobile Ad Management"},
  { id: "COMMENT_EMBED", name: "Commenting", section: "Engagement Products"},
  { id: "INTERSTITIAL", name: "Interstitial Ad Unit", section: "Full Ad Management"},
  { id: "IN_STREAM_VIDEO", name: "In-stream Ad Unit", section: "Video Ad Management"},
  { id: "OUT_STREAM_VIDEO", name: "Out-stream Ad Unit", section: "Video Ad Management"},
  { id: "PREBID_ADAPTER", name: "Prebid Adapter", section: "SSP"},
  { id: "QUESTION_EMBED", name: "Trivia & Polls (CEU)", section: "Engagement Products"},
  { id: "STANDALONE", name: "FAM & Standalone Ad Units", section: "Full Ad Management"}
]

const usageFeesProductMapping = {
  "Engagement Products": [],
  "Full Ad Management": [],
  "Video Ad Management": [],
  "Mobile Ad Management": [],
  "SSP": []
}

export { usageFeesColHeads as USAGE_FEES_COL_HEADS }
export { usageFeesProductInfo as USAGE_FEES_PRODUCT_INFO }
export { usageFeesProductMapping as USAGE_FEES_PRODUCT_MAPPING }